import {
  Link as GLink,
  useI18next,
  useTranslation,
} from 'gatsby-plugin-react-i18next';
import React, { useEffect, useRef } from 'react';

import LinkBar from '../components/linkBar';
import { ServicesDisciplines } from '../containers/servicesDisciplines';
import { ServicesDiseases } from '../containers/servicesDiseases';
import { ServicesMethods } from '../containers/servicesMethods';
import { ServicesPricing } from '../containers/servicesPricing';
import { useScrollTo } from '../hooks/useScrollTo';
import { MainContent } from '../styles';
import { GraphQLData } from '../types';
import { getLocalizationObj } from '../utilities/getLocalizationObj';

interface LeistungenProps {
  data: GraphQLData;
  location: any;
}

export const LeistungenTemplateMain = ({ location, data }: LeistungenProps) => {
  const { t } = useTranslation();

  const linkBarItems = [
    {
      title: t('methods_short'),
      to: `/${t('services').toLowerCase()}/#methods`,
    },
    {
      title: t('disziplines'),
      to: `/${t('services').toLowerCase()}/#disziplinen`,
    },
    {
      title: t('treatment fields'),
      to: `/${t('services').toLowerCase()}/#symptoms`,
    },
    {
      title: t('costs'),
      to: `/${t('services').toLowerCase()}/#kosten`
    },
  ];

  const item0ref = useRef();
  const item1ref = useRef();
  const item2ref = useRef();
  const item3ref = useRef();

  // handle scroll to element
  const scrollTo = useScrollTo();
  useEffect(() => {
    const area = location.hash.slice(1);
    if (area === 'methods' && item0ref) scrollTo(item0ref);
    if (area === 'disziplinen' && item1ref) scrollTo(item1ref);
    if (area === 'symptoms' && item2ref) scrollTo(item2ref);
    if (area === 'pricing' && item3ref) scrollTo(item3ref);
  }, [location.hash]);

  const { methods, disciplines, service, therapists } = data.strapi || {};
  const {
    disciplineTitle,
    disciplineSubtitle,
    methodsTitle,
    methodsSubtitle,
    diseaseTitle,
    competencyCover,
    methodCover,
    diseaseInformation,
    diseases,
    pricingTitle,
    pricingSubtitle,
  } = getLocalizationObj(service) || {};

  return (
    <MainContent pt={['6', '6']}>
      <LinkBar
        services
        items={linkBarItems}
        refs={[item0ref, item1ref, item2ref, item3ref]}
      />
      <ServicesMethods
        ref={item0ref}
        {...{ methodsTitle, methodsSubtitle, methods, methodCover }}
      />
      <ServicesDisciplines
        ref={item1ref}
        {...{
          disciplineTitle,
          disciplineSubtitle,
          disciplines,
          competencyCover,
        }}
      />
      <ServicesDiseases
        ref={item2ref}
        {...{ diseaseTitle, diseaseInformation, diseases }}
      />
      <ServicesPricing
        ref={item3ref}
        {...{ pricingTitle, pricingSubtitle, therapists }}
      />
    </MainContent>
  );
};
